import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex border-l-4 border-brand-500 bg-white text-slate-700 px-4 py-1 rounded tracking-wide shadow items-center text-brand-400"
};
const _hoisted_2 = { class: "success-message" };
const _hoisted_3 = {
    key: 1,
    class: "flex border-l-4 border-error-500 bg-error-50 text-slate-700 px-4 py-1 rounded tracking-wide shadow items-center text-error-400"
};
const _hoisted_4 = { class: "error-message" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.form.successful())
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-6 w-6 mr-2",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                }, [
                    _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                    })
                ], -1)),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.form.getSuccessMessage()), 1)
            ]))
            : _createCommentVNode("", true),
        (_ctx.form.noFieldErrors())
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-6 w-6 mr-2",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                }, [
                    _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                    })
                ], -1)),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.form.getErrorMessage()), 1)
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
